// src/AddToHomeScreenButton.jsx
import React from "react";
import useAddToHomeScreen from "./useAddToHomeScreen";

export default function AddToHomeScreenButton() {
 const { triggerInstall, platform, isStandalone } = useAddToHomeScreen();

   if (isStandalone) return null; // already installed

  const handleClick = async () => {
    const result = await triggerInstall();
    if (result?.outcome === "manual") {
      alert(result.message); // or show custom modal
    }
  };


 
  return (
    <button
      onClick={handleClick}
      className="px-4 py-2 rounded-lg shadow-md bg-green-600 hover:bg-green-700"
     style={{
        background: 'none',
        border: 'none',
        color: '#007bff',
        fontSize: '18px',
        cursor: 'pointer',
        display: 'block',
        margin: '0 auto',
        padding: '8px',
        textDecoration: 'none'
      }}
    >
      <span>📲  {platform === "chromium" ? "Add to Home Screen" : "How to Install"}</span>
    </button>
  );
}
